import { Paginator } from 'primereact/paginator';
import { useState, useEffect, useRef, useCallback, Suspense } from 'react';
import { getAttendance, getGeoTagRegion } from './Services/AttendanceService';
import { EmployeeAwardsYears } from '../AwardList/Services/awardService';
import { GetMasterTypeData } from '../../../Services/Global-Services/GlobalServices';
import { getEmployeeList } from '../EmployeeList/Service/employeeService';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';


const Attendance_Register = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [editedCells, setEditedCells] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState('');
  const [attendanceList, setAttendanceList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [summary, setSummary] = useState({});
  const [employees, setEmployees] = useState([]);
  const [attMatrix, setAttMatrix] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // 0–11
  const currentMonth = new Date(selectedYear, selectedMonth, 1);
  const [masterYear, setMasterYear] = useState([]);
  const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const [zoneCategoryType, setZoneCategoryType] = useState([])
  const [regionCategoryType, setRegionCategoryType] = useState([])
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const searchTimeout = useRef(null);
  const [reportingHirechy, setReportingHirechy] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [selectedDrawerStatus, setSelectedDrawerStatus] = useState(null);

  const TOTAL_DAYS = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0
  ).getDate();

  const TODAY =
    currentMonth.getMonth() === new Date().getMonth() &&
      currentMonth.getFullYear() === new Date().getFullYear()
      ? new Date().getDate()
      : TOTAL_DAYS;
  const [picker, setPicker] = useState({
    show: false,
    ri: null,
    di: null,
    x: 0,
    y: 0
  });

  const showToast = (msg) => setToast(msg);



  const DOW_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const APR_START_DOW = 3;

  const HOLIDAYS = { 14: 'Ambedkar Jayanti' };
  const STATUS_POOL = ['P', 'P', 'P', 'P', 'P', 'P', 'A', 'L', 'WFH', 'P', 'P', 'LV', 'P', 'P', 'WFH', 'P', 'P', 'P', 'A', 'P', 'P', 'P', 'P', 'L', 'P'];

  const ATT_STATUS = {
    P: { label: 'P', cls: 'att-P', tip: 'Present' },
    A: { label: 'A', cls: 'att-A', tip: 'Absent' },
    L: { label: 'L', cls: 'att-L', tip: 'Late' },
    WFH: { label: 'WFH', cls: 'att-WFH', tip: 'Work From Home' },
    LV: { label: 'LV', cls: 'att-LV', tip: 'Leave' },
    WO: { label: 'WO', cls: 'att-WO', tip: 'Week Off' },
    H: { label: 'H', cls: 'att-H', tip: 'Holiday' },
    HD: { label: '½', cls: 'att-HD', tip: 'Half Day' },
    '': { label: '', cls: '', tip: '' },
  };

  const LOCKED_STATUSES = ['WO', 'H', '', 'LV', 'WFH'];

  const COL_WIDTHS = { c1: 80, c2: 150, c3: 170, c4: 130 };

  useEffect(() => {
    getAwardYearList();
    ReportOrHierarchy();
    getMasterTicketCategory()
    getGeoTagRegionCategory()
  }, []);




  useEffect(() => {
    setFirst(0);
    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);

    getAttendanceList(1, rows, start.toISOString(), end.toISOString(), searchValue);
  }, [selectedMonth, selectedYear, rows, selectedZone, selectedRegion]);

  const freezeTd = (col, extra = {}) => ({
    position: 'sticky',
    left: col === 'c1' ? 0
      : col === 'c2' ? COL_WIDTHS.c1
        : col === 'c3' ? COL_WIDTHS.c1 + COL_WIDTHS.c2
          : COL_WIDTHS.c1 + COL_WIDTHS.c2 + COL_WIDTHS.c3,
    zIndex: 3,
    minWidth: COL_WIDTHS[col],
    maxWidth: COL_WIDTHS[col],
    background: 'var(--bg-card, #fff)',
    ...extra,
  });



  const freezeTh = (col) => freezeTd(col, { zIndex: 5 });
  function getDOW(d) {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    // console.log(currentMonth, currentYear , 'month-year');
    // console.log(new Date(currentYear, currentMonth, 1).getDay())
    const monthStart = new Date(currentYear, currentMonth, 1).getDay()
    return (monthStart + d - 1) % 7;
  }
  // return (APR_START_DOW + d - 1) % 7; }
  function isWeekend(d) { const w = getDOW(d); return w === 0 || w === 6; }

  function seedStatus(d, ri) {
    if (isWeekend(d)) return 'WO';
    if (HOLIDAYS[d]) return 'H';
    if (d > TODAY) return '';
    return STATUS_POOL[(ri * 7 + d) % STATUS_POOL.length];
  }

  // function buildInitialMatrix() {
  //   return employees.map((_, ri) =>
  //     Array.from({ length: TOTAL_DAYS }, (_, di) => seedStatus(di + 1, ri))
  //   );
  // }




  const STATUS_LABEL = {
    P: 'Present',
    A: 'Absent',
    WFH: 'Work From Home',
    LV: 'Leave',
    WO: 'Week Off',
    HD: 'Half Day'
  };

  function AttCell({ status, ri, di, editMode, isEdited }) {
    const cfg = ATT_STATUS[status] ?? ATT_STATUS[''];

    return (
      <td>
        <span
          className={`att-badge att-badge-sm ${cfg.cls}`}
          onClick={() => handleOpenDrawer(ri, di)}
        >
          {cfg.label}
        </span>
      </td>
    );
  }

  const handleOpenDrawer = (ri, di) => {
    const emp = attendanceList[ri];
    const employee = employees[ri];
    const dayKey = `D${di + 1}`;
    const dayData = emp?.[dayKey];

    const currentStatus = dayData?.StatusCode || '';

    setDrawerData({
      empId: employee.id,
      name: employee.name,
      designation: employee.desig,
      location: employee.region,
      date: dayData?.AttendanceDate,
      status: currentStatus,
      checkIn: dayData?.CheckIn,
      checkOut: dayData?.CheckOut,
      fullData: dayData,
      ri,   // ← row index save karo matrix update ke liye
      di    // ← day index save karo
    });

    setSelectedDrawerStatus(currentStatus); // ← current status pre-select
    setShowDrawer(true);
  };

  // 2. Save function — update API call + matrix update
  const handleDrawerSave = async () => {
    if (!selectedDrawerStatus) {
      alert("Please select a status");
      return;
    }

    const params = {
      EmployeeId: drawerData.empId,
      AttendanceDate: drawerData.date,
      StatusCode: selectedDrawerStatus,
      // Apni update API ke hisaab se aur fields add karo
    };

    try {
      // ✅ Apni update API call karo yahan
      // const response = await updateAttendance(params);

      // ✅ Local matrix bhi update karo (UI immediately reflect kare)
      setAttMatrix(prev => {
        const next = prev.map(r => [...r]);
        next[drawerData.ri][drawerData.di] = selectedDrawerStatus;
        return next;
      });

      showToast("Attendance updated successfully!");
      setShowDrawer(false);
    } catch (error) {
      console.error("Update failed:", error);
      showToast("Update failed. Please try again.");
    }
  };


  function StatusPicker({ picker, onApply, onClose }) {
    const ref = useRef(null);
    useEffect(() => {
      if (!picker.show) return;
      const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
      document.addEventListener('mousedown', handler);
      return () => document.removeEventListener('mousedown', handler);
    }, [picker.show, onClose]);

    if (!picker.show) return null;
    return (
      <div className='attendance-status' ref={ref} id="statusPicker" style={{
        position: 'fixed', top: picker.y, left: picker.x, zIndex: 99999,
      }}>
        <div className="sp-title">Override Status</div>
        {[
          { code: 'P', color: '#16a34a', label: 'Present' },
          { code: 'A', color: '#dc2626', label: 'Absent' },
          { code: 'L', color: '#d97706', label: 'Late' },
          { code: 'HD', color: '#0284c7', label: 'Half Day' },
        ].map(({ code, color, label }) => (
          <div key={code} className="sp-opt" onClick={() => onApply(code)}>
            <span className="sp-dot" style={{ background: color }} />{label}
          </div>
        ))}
        <hr style={{ margin: '.3rem 0', borderColor: 'var(--border)' }} />
        <div className="sp-opt cancle" onClick={onClose} style={{ color: 'var(--text-muted)', fontSize: '.74rem' }}>
          <i className="fa fa-times" style={{ width: 10 }} /> Cancel
        </div>
      </div>
    );
  }

  function MarkAttendanceModal({ show, onClose }) {
    if (!show) return null;
    return (
      <div className={`og-modal-overlay${show ? ' open' : ''}`} style={{ display: 'flex' }} onClick={onClose}>
        <div className="og-modal" onClick={e => e.stopPropagation()}>
          <div className="og-modal-header">
            <i className="fa fa-calendar-plus-o" style={{ color: 'var(--primary)', fontSize: '1.1rem' }} />
            <h5>Mark Attendance</h5>
            <button className="modal-close" onClick={onClose}><i className="fa fa-times" /></button>
          </div>
          <div className="og-modal-body">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label className="og-label">Employee <span className="req">*</span></label>
                <select className="og-select">
                  <option>— Select Employee —</option>
                  {employees.map(e => <option key={e.id}>{e.id} – {e.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="og-label">Date <span className="req">*</span></label>
                <input type="date" className="og-input" defaultValue="2026-04-08" />
              </div>
              <div className="form-group">
                <label className="og-label">Status <span className="req">*</span></label>
                <select className="og-select">
                  <option value="P">Present</option>
                  <option value="A">Absent</option>
                  <option value="L">Late</option>
                  <option value="HD">Half Day</option>
                  <option value="WFH">Work From Home</option>
                </select>
              </div>
              <div className="form-group">
                <label className="og-label">Check-In Time</label>
                <input type="time" className="og-input" defaultValue="09:15" />
              </div>
              <div className="form-group">
                <label className="og-label">Check-Out Time</label>
                <input type="time" className="og-input" defaultValue="18:30" />
              </div>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label className="og-label">Override Reason</label>
                <input type="text" className="og-input" placeholder="Reason for manual override…" />
              </div>
            </div>
          </div>
          <div className="og-modal-footer">
            <button className="btn-og btn-og-secondary" onClick={onClose}>Cancel</button>
            <button className="btn-og btn-og-primary" onClick={onClose}>
              <i className="fa fa-check" /> Mark Attendance
            </button>
          </div>
        </div>
      </div>
    );
  }

  function Toast({ message, onDone }) {
    useEffect(() => {
      if (!message) return;
      const t = setTimeout(onDone, 2500);
      return () => clearTimeout(t);
    }, [message, onDone]);
    if (!message) return null;
    return (
      <div style={{
        position: 'fixed', bottom: 24, right: 24, background: 'var(--primary)', color: '#fff',
        padding: '.6rem 1.2rem', borderRadius: 8, fontSize: '.82rem', fontWeight: 600,
        boxShadow: '0 4px 16px rgba(0,0,0,.18)', zIndex: 99999,
      }}>
        {message}
      </div>
    );
  }
  // Cell click → open picker using viewport (fixed) coords
  const handleCellClick = useCallback((e, ri, di) => {
    const rect = e.target.getBoundingClientRect();
    setPicker({ show: true, ri, di, x: rect.left - 20, y: rect.bottom + 4 });
  }, []);

  const applyStatus = useCallback((status) => {
    const { ri, di } = picker;
    if (ri === null) return;

    setAttMatrix(prev => {
      const next = prev.map(r => [...r]);
      next[ri][di] = status;
      return next;
    });

    setEditedCells(prev => ({ ...prev, [`${ri}_${di}`]: status }));

    // ✅ CLOSE PICKER
    setPicker({ show: false, ri: null, di: null, x: 0, y: 0 });

  }, [picker]);

  const closePicker = useCallback(() => {
    setPicker({ show: false, ri: null, di: null, x: 0, y: 0 });
  }, []);


  function toggleEditMode() {
    setEditMode(prev => { if (prev) setEditedCells({}); return !prev; });
  }

  function saveEdits() {
    setEditMode(false);
    setEditedCells({});
  }


  const onPageChange = (event) => {
    const page = event.first / event.rows + 1;

    setFirst(event.first);
    setRows(event.rows);

    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);

    getAttendanceList(page, event.rows, start.toISOString(), end.toISOString(), searchValue);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);

    if (!value) {
      setSuggestions([]);
      setShowSuggestions(false);
    } else {
      const filtered = reportingHirechy
        .filter(emp =>
          emp.FullName?.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10); // limit suggestions

      setSuggestions(filtered);
      setShowSuggestions(true);
    }

    // existing debounce API call
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setFirst(0);

      const start = new Date(selectedYear, selectedMonth, 1);
      const end = new Date(selectedYear, selectedMonth + 1, 0);

      getAttendanceList(1, rows, start.toISOString(), end.toISOString(), value);
    }, 500);
  };

  const handleSuggestionClick = (name) => {
    setSearchValue(name);
    setShowSuggestions(false);

    setFirst(0);

    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);

    getAttendanceList(1, rows, start.toISOString(), end.toISOString(), name);
  };

  async function getAttendanceList(page = 1, size = rows, fromDate, toDate, search = searchValue) {
    setLoading(true);
    const params = {
      EmployeeId: 0,
      PageNumber: page,
      PageSize: size,
      Search: search || '',
      FromDate: fromDate,
      ToDate: toDate,
      ZoneId: Number(selectedZone) || 0,     // ✅ use state
      RegionId: Number(selectedRegion) || 0
    };

    try {
      const response = await getAttendance(params);
      setLoading(false);
      const results = response?.Data?.AttendanceResults || [];
      setAttendanceList(results);
      if (!results.length) {
        setAttendanceList([]);
        setEmployees([]);
        setAttMatrix([]);
        setTotalRecords(0);
        setSummary({});
        return;
      }


      // ✅ Summary (take from first row or API root)
      const first = results[0];
      setSummary({
        presentMTD: first?.presentMTD,
        absentMTD: first?.AbsentMTD,
        leaveMTD: first?.LeaveMTD,
        wfhMTD: first?.WFHMTD,
        attendanceMTD: first?.AttendanceMTD
      });

      // ✅ employees list
      const employees = results.map(emp => ({
        id: emp.EmployeeId,
        name: emp.EmployeeName,
        desig: emp.CurrentDesignation || '-',
        region: emp.CurrentWorkLocation || '-'
      }));

      // ✅ Attendance matrix
      const matrix = results.map(emp => {
        const row = [];

        for (let d = 1; d <= TOTAL_DAYS; d++) {
          if (d > TODAY) {
            row.push('');
            continue;
          }

          const key = `D${d}`;
          const dayData = emp[key];

          if (!dayData || !dayData.StatusCode) {
            row.push('');
          } else {
            row.push(dayData.StatusCode);
          }
        }

        return row;
      });

      // ✅ Set both
      setEmployees(employees);      // 👈 NEW STATE
      setAttMatrix(matrix);
      setTotalRecords(response?.Data?.EmployeeCount || 0);        // 👈 NEW STATE
      setSummary({
        total: response?.Data?.EmployeeCount || 0,
        present: Number(response?.Data?.Present || 0),
        absent: Number(response?.Data?.Absent || 0),
        leave: Number(response?.Data?.LeaveToday || 0),
        wfh: Number(response?.Data?.WFHToday || 0),
        late: Number(response?.Data?.LessCount || 0)
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }


  function EmpRow({ emp, ri, attRow, editMode, editedCells, onCellClick }) {
    let p = 0, a = 0, l = 0, work = 0;
    attRow.slice(0, TODAY).forEach(s => {
      if (!['WO', 'H', '', 'LV'].includes(s)) {
        work++;
        if (s === 'P' || s === 'HD') p++;
        else if (s === 'A') a++;
      }
      if (s === 'LV') l++;
    });
    const pct = work > 0 ? Math.round((p / work) * 100) : '–';
    const pctColor = pct === '–' ? 'var(--text-muted)' : pct >= 90 ? '#16a34a' : pct >= 75 ? '#d97706' : '#dc2626';

    return (
      <tr>
        {/* Frozen columns — inline sticky styles */}
        <td style={freezeTd('c1')}>
          <span style={{ fontSize: '.7rem', fontWeight: 700, color: 'var(--primary)' }}>{emp.id}</span>
        </td>
        <td style={freezeTd('c2')}>
          <div className="emp-name-cell"><div className="ename">{emp.name}</div></div>
        </td>
        <td style={freezeTd('c3')}>
          <span className="desig-cell">{emp.desig}</span>
        </td>
        <td style={freezeTd('c4')}>
          <span className="loc-cell">
            <i className="fa fa-map-marker" style={{ fontSize: '.6rem' }} />{' '}
            {emp.region}
          </span>
        </td>

        {attRow.slice(0, TODAY).map((st, di) => (
          <AttCell
            key={di}
            status={st}
            ri={ri}
            di={di}
            editMode={editMode}
            isEdited={!!editedCells[`${ri}_${di}`]}
            onCellClick={onCellClick}
          />
        ))}

        <td style={{ fontWeight: 700, fontSize: '.74rem', color: '#16a34a', whiteSpace: 'nowrap' }}>{p}</td>
        <td style={{ fontWeight: 700, fontSize: '.74rem', color: '#dc2626', whiteSpace: 'nowrap' }}>{a}</td>
        <td style={{ fontWeight: 700, fontSize: '.74rem', color: '#1d4ed8', whiteSpace: 'nowrap' }}>{l}</td>
        <td style={{ fontWeight: 700, fontSize: '.74rem', color: pctColor, whiteSpace: 'nowrap' }}>{pct}{pct !== '–' ? '%' : ''}</td>
      </tr>
    );
  }


  async function getAwardYearList() {
    const params = { OrgId: userDetails?.OrgId };

    try {
      const response = await EmployeeAwardsYears(params);

      const years = response?.Data || [];

      const sortedYears = [...years].sort((a, b) => b.Year - a.Year);

      setMasterYear(sortedYears);
      if (sortedYears.length > 0) {
        setSelectedYear(sortedYears[0].Year);
      }

    } catch (err) {
      console.error("Year API Error:", err);
    }
  }

  async function getGeoTagRegionCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgRegion",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setRegionCategoryType(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgZone",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setZoneCategoryType(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const clearLocFilters = () => {
    setSelectedZone("");
    setSelectedRegion("");   // 👈 missing
    setSearchValue("");
    setFirst(0);

    const start = new Date(selectedYear, selectedMonth, 1);
    const end = new Date(selectedYear, selectedMonth + 1, 0);

    getAttendanceList(1, rows, start.toISOString(), end.toISOString(), "");
  };

  const handleExport = () => {
    if (!employees.length) {
      alert("No data to export");
      return;
    }
    const headers = [
      "Emp ID",
      "Employee Name",
      "Designation",
      "Location",
      ...Array.from({ length: TODAY }, (_, i) => `Day ${i + 1}`),
      "Present",
      "Absent",
      "Leave",
      "Attendance %"
    ];
    const rows = employees.map((emp, ri) => {
      const attRow = attMatrix[ri] || [];

      let p = 0, a = 0, l = 0, work = 0;

      attRow.slice(0, TODAY).forEach(s => {
        if (!['WO', 'H', '', 'LV'].includes(s)) {
          work++;
          if (s === 'P' || s === 'HD') p++;
          else if (s === 'A') a++;
        }
        if (s === 'LV') l++;
      });

      const pct = work > 0 ? Math.round((p / work) * 100) : '';

      return [
        emp.id,
        emp.name,
        emp.desig,
        emp.region,
        ...attRow.slice(0, TODAY),
        p,
        a,
        l,
        pct ? `${pct}%` : ''
      ];
    });

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map(row => row.map(val => `"${val ?? ""}"`).join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);

    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `Attendance_${MONTH_NAMES[selectedMonth]}_${selectedYear}.csv`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  async function ReportOrHierarchy() {
    const params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };

    try {
      let res = await getEmployeeList(params1);
      const list = res?.Data || [];
      setReportingHirechy(list);
    } catch (error) {
      console.error(error);
    }
  }




  return (
    <div>
      <div className="container-fluid">
        <div className="page-head">
          <div>
            <h2><i className="fa fa-calendar-check-o head-icon" /> Attendance Register</h2>
            <p>Monthly attendance overview &nbsp;·&nbsp; April 2026 &nbsp;·&nbsp; All Zones</p>
          </div>
          <div className="head-actions">
            {/* <button className="btn-og btn-og-secondary btn-og-sm" onClick={toggleEditMode}>
              <i className={`fa fa-${editMode ? 'times' : 'pencil'}`} />
              {editMode ? ' Exit Edit' : ' Edit Mode'}
            </button> */}
            <button className="btn-og btn-og-secondary btn-og-sm" onClick={handleExport}>
              <i className="fa fa-download" /> Export
            </button>
            {/* <button className="btn-og theme-color btn-og-sm" onClick={() => setShowModal(true)}>
              <i className="fa fa-plus" /> Mark Attendance
            </button> */}
          </div>
        </div>

        {/* Stat Cards */}
        <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(6,1fr)' }}>
          {[
            {
              cls: 'sc-total',
              label: 'Total Employees',
              val: summary.total,
              icon: 'fa-users'
            },
            {
              cls: 'sc-present',
              label: 'Present Today',
              val: summary.present,
              icon: 'fa-check-circle'
            },
            {
              cls: 'sc-absent',
              label: 'Absent Today',
              val: summary.absent,
              icon: 'fa-times-circle'
            },
            {
              cls: 'sc-wfh',
              label: 'WFH Today',
              val: summary.wfh,
              icon: 'fa-home'
            },
            {
              cls: 'sc-leave',
              label: 'On Leave',
              val: summary.leave,
              icon: 'fa-plane'
            },
            {
              cls: 'sc-late',
              label: 'Unavailable',
              val: summary.late,
              icon: 'fa-clock-o'
            }
          ].map(c => (
            <div key={c.cls} className={`stat-card ${c.cls}`}>
              <div className="sc-label">{c.label}</div>
              <div className="sc-value">{c.val}</div>
              <div className="sc-sub">{c.sub}</div>
              <i className={`fa ${c.icon} sc-icon`} />
            </div>
          ))}
        </div>

        {/* Filter Bar */}
        <div className="filter-bar">
          {/* <span className="filter-label"><i className="fa fa-filter" />&nbsp; Filters</span> */}
          <input
            type="month"
            className="og-input"
            value={`${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`}
            style={{ maxWidth: 155 }}
            onChange={(e) => {
              const value = e.target.value; // format: YYYY-MM
              if (!value) return;
              const [year, month] = value.split('-');
              setSelectedYear(Number(year));
              setSelectedMonth(Number(month) - 1); // 👈 IMPORTANT (0-based)
              setFirst(0);
            }}
          />

          <select
            className="og-select"
            style={{ minWidth: 135 }}
            value={selectedZone}
            onChange={(e) => {
              setSelectedZone(e.target.value);
              setSelectedRegion("");
              setFirst(0);
            }}
          >
            <option value="">All Zones</option>
            {zoneCategoryType.map((zone) => (
              <option key={zone.Id} value={zone.Id}>
                {zone.Name}
              </option>
            ))}
          </select>


          <select
            className="og-select"
            style={{ minWidth: 150 }}
            value={selectedRegion}
            disabled={!selectedZone}   // 👈 key change
            onChange={(e) => {
              setSelectedRegion(e.target.value);
              setFirst(0);
            }}
          >
            <option value="">All Region</option>
            {regionCategoryType
              .filter(r => String(r.Code) === String(selectedZone))
              .map((region) => (
                <option key={region.Id} value={region.Id}>
                  {region.Name}
                </option>
              ))}
          </select>

          {/* <select className="og-select" value={filters.project} style={{ minWidth: 190 }}
            onChange={e => updateFilter('project', e.target.value)}>
            <option value="">All Clients / Projects</option>
            <optgroup label="Tech Sector">
              <option value="infosys-erp">Infosys – ERP Migration</option>
              <option value="tcs-cloud">TCS – Cloud Transformation</option>
              <option value="wipro-ams">Wipro – AMS Support</option>
            </optgroup>
            <optgroup label="Banking & Finance">
              <option value="hdfc-crm">HDFC Bank – CRM Module</option>
              <option value="axis-portal">Axis Bank – Portal Dev</option>
            </optgroup>
            <optgroup label="Internal">
              <option value="internal">Internal / Bench</option>
            </optgroup>
          </select>

          <select className="og-select" value={filters.manager} style={{ minWidth: 210 }}
            onChange={e => updateFilter('manager', e.target.value)}>
            <option value="">All Employees (Full Hierarchy)</option>
            <optgroup label="Senior Management">
              <option value="arun">↳ Arun Mishra (Director)</option>
              <option value="priya">↳ Priya Sharma (VP Engineering)</option>
            </optgroup>
            <optgroup label="Mid Management">
              <option value="rahul">&nbsp;&nbsp;↳ Rahul Singh (Eng Lead)</option>
              <option value="neha">&nbsp;&nbsp;↳ Neha Gupta (HR Manager)</option>
              <option value="vikram">&nbsp;&nbsp;↳ Vikram Patel (Sales Head)</option>
            </optgroup>
          </select> */}

          {/* <div className="search-wrap">
            <i className="fa fa-search" />
            <input type="text" className="og-input" placeholder="Search by name"
              value={searchValue}
              onChange={(e) => handleSearchChange(e.target.value)} />
          </div> */}


          <div className="search-wrap" style={{ position: "relative" }}>
            <i className="fa fa-search" />

            <input
              type="text"
              className="og-input"
              placeholder="Search by name"
              value={searchValue}
              onChange={(e) => handleSearchChange(e.target.value)}
              onFocus={() => searchValue && setShowSuggestions(true)}
            />

            {/* 🔽 Suggestion Dropdown */}
            {showSuggestions && suggestions.length > 0 && (
              <ul className="suggestion-box">
                {suggestions.map((emp) => (
                  <li
                    key={emp.EmpId}
                    onClick={() => handleSuggestionClick(emp.FullName)}
                  >
                    {emp.FullName}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="divider" />
          <button className="btn-og btn-og-secondary btn-og-sm" onClick={clearLocFilters}>
            <i className="fa fa-times" /> Clear
          </button>
        </div>



        {/* Legend */}
        <div className="legend-strip">
          <span style={{ fontSize: '.72rem', fontWeight: 700, color: 'var(--text-muted)', paddingRight: '.4rem' }}>Legend:</span>
          {[
            { cls: 'att-P', label: 'P', desc: 'Present' },
            { cls: 'att-A', label: 'A', desc: 'Absent' },
            { cls: 'att-L', label: 'L', desc: 'Less' },
            { cls: 'att-WFH', label: 'WFH', desc: 'Work From Home' },
            { cls: 'att-LV', label: 'LV', desc: 'Leave' },
            { cls: 'att-WO', label: 'WO', desc: 'Week Off' },
            { cls: 'att-H', label: 'H', desc: 'Holiday' },
            { cls: 'att-HD', label: '½', desc: 'Half Day' },
          ].map(({ cls, label, desc }) => (
            <div key={cls} className="legend-item">
              <span className={`att-badge att-badge-sm ${cls}`}>{label}</span> {desc}
            </div>
          ))}
          <span style={{ fontSize: '.7rem', color: 'var(--text-muted)', marginLeft: '.25rem' }}>
            <i className="fa fa-info-circle" style={{ marginRight: '.25rem' }} />
            Enable Edit Mode to override. Leave / WFH / Week Off cells are locked.
          </span>
        </div>

        {/* Edit Banner */}
        {editMode && (
          <div className="edit-banner active">
            <i className="fa fa-pencil-square-o" />&nbsp;
            Edit mode active — click any editable cell to change status.{' '}
            <i className="fa fa-lock" /> = non-editable.
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '.5rem' }}>
              <button className="btn-og btn-og-primary btn-og-sm" onClick={saveEdits}>
                <i className="fa fa-save" /> Save
              </button>
              <button className="btn-og btn-og-secondary btn-og-sm" onClick={toggleEditMode}>Cancel</button>
            </div>
          </div>
        )}

        {/* TABLE CARD */}
        <div className="og-card">
          <div className="og-card-header">
            <div>
              <h5> {MONTH_NAMES[selectedMonth]} {selectedYear} — Attendance Register</h5>
              {/* <div className="sub">
                {searchValue
                  ? `No results found for "${searchValue}"`
                  : "No employees match current filters"}
              </div> */}
            </div>
            <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
              <div className="month-nav">
                <div className="month-nav">
                  {MONTH_NAMES.map((m, index) => (
                    <button
                      key={m}
                      className={`month-tab ${selectedMonth === index ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedMonth(index);
                        showToast(`Loading ${m} ${selectedYear} attendance…`);
                      }}
                    >
                      {m}
                    </button>
                  ))}
                </div>
              </div>

              {/* <button className="btn-og btn-og-secondary btn-og-sm" style={{ background: '#e8edf2' }}>
                <select value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))} style={{ border: 'none', background: 'transparent' }}>
                  {masterYear.map((y, i) => (
                    <option key={i} value={y.Year}>
                      {y.Year}
                    </option>
                  ))}
                </select>
              </button> */}


            </div>
          </div>

          <div style={{
            overflowX: 'auto',
            overflowY: 'visible',
            position: 'relative',
            width: '100%',
            WebkitOverflowScrolling: 'touch',
          }}>
            <table className="att-reg-table" style={{
              borderCollapse: 'separate',   /* ← critical for sticky cols */
              borderSpacing: 0,
              minWidth: '100%',
            }}>
              <thead>
                <tr>
                  <th style={freezeTh('c1')}>Emp ID</th>
                  <th style={freezeTh('c2')}>Employee</th>
                  <th style={freezeTh('c3')}>Designation</th>
                  <th style={freezeTh('c4')}>Location</th>
                  {Array.from({ length: TODAY }, (_, i) => i + 1).map(d => {
                    const dow = getDOW(d);
                    console.log(dow)
                    let cls = 'day-h';
                    if (dow === 0) cls += ' day-sun';
                    if (dow === 6) cls += ' day-sat';
                    if (d === TODAY) cls += ' day-today';
                    if (d > TODAY) cls += ' day-future';
                    return (
                      <th key={d} className={cls} title={HOLIDAYS[d] || undefined}>
                        {d}<br />
                        <span style={{ fontWeight: 400, fontSize: '.58rem' }}>{DOW_NAMES[dow]}</span>
                      </th>
                    );
                  })}
                  <th className="sum-h" title="Days Present">P</th>
                  <th className="sum-h" title="Days Absent">A</th>
                  <th className="sum-h" title="Leave days">L</th>
                  <th className="sum-h" title="Attendance %">%</th>
                </tr>
              </thead>
              <tbody>
                {employees.length === 0 ? (
                  <tr>
                    <td colSpan={4 + TODAY + 4}
                      style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
                      No employees match current filters
                    </td>
                  </tr>
                ) : (
                  employees.map((emp, ri) => (
                    <EmpRow
                      key={emp.id}
                      emp={emp}
                      ri={ri}
                      attRow={attMatrix[ri] || []}
                      editMode={editMode}
                      editedCells={editedCells}
                      onCellClick={handleCellClick}
                      fullRow={attendanceList[ri]}
                    />
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination footer */}
          <div className="sticky-footer">
            <div className="og-pagination">
              <div className="page-size-wrap">
                <div className="sticky-footer" style={{ position: 'relative' }}>
                  <div className="og-pagination">
                    <Paginator
                      first={first}
                      rows={rows}
                      totalRecords={totalRecords}
                      rowsPerPageOptions={[10, 20, 50, 100]}   // 👈 THIS replaces your select
                      onPageChange={onPageChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {Object.keys(editedCells).length > 0 && (
              <div style={{ fontSize: '.75rem', color: 'var(--primary)', fontWeight: 600 }}>
                <i className="fa fa-edit" /> {Object.keys(editedCells).length} cell(s) modified — unsaved
              </div>
            )}
          </div>
        </div>

      </div>

      {showDrawer && (
        <>
          <div
            className="drawer-overlay"
            onClick={() => setShowDrawer(false)}
          />
          <div className={`side-drawer ${showDrawer ? 'open' : ''}`}>
            <h4>Edit attendance<span></span>
              <svg onClick={() => setShowDrawer(false)} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg></h4>
            <div className="profile-band">
              <div className="av">LST</div>
              <div>
                <p className="pname">{drawerData?.name}</p>
                <div className="pbadge-row">
                  <span className="pbadge id-badge"><i className="ti ti-hash" style={{ fontSize: '9px', verticalAlign: '-1px' }} aria-hidden="true"></i> EMP {drawerData?.empId}</span>
                  <span className="pbadge">{drawerData?.designation}</span>
                </div>
              </div>
            </div>
            <div className="location-band">
              <div className="today-left">
                <p className="tl1"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16">
                  <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                </svg>Location</p>
                <p className="td" id="todayLabel">{drawerData?.location}</p>
              </div>
              <div className="today-status" id="todayStatusBadge">
                <span className="ts-dot" id="todayDot" style={{ background: '#639922' }}></span>
                <span className="ts-label" id="todayStatusText" style={{ color: '#3B6D11' }}>{STATUS_LABEL[drawerData?.status] || '-'}</span>
              </div>
            </div>
            <div className="picker-panel">
              <p className="picker-label">Mark as</p>
              <p className="picker-sel-info" id="selInfo"><b>{drawerData?.date}</b> — {drawerData?.status}</p>
              <div className="status-grid">
                {[
                  { code: 'P', icon: 'ti-circle-check', label: 'Present', cls: 'act' },
                  { code: 'A', icon: 'ti-circle-x', label: 'Absent', cls: 'sa' },
                  { code: 'WFH', icon: 'ti-home', label: 'WFH', cls: 'swfh' },
                  { code: 'LV', icon: 'ti-plane', label: 'Leave', cls: 'slv' },
                  { code: 'WO', icon: 'ti-moon', label: 'Week off', cls: 'swo' },
                  { code: 'HD', icon: 'ti-adjust-horizontal', label: 'Half day', cls: 'shd' },
                ].map(({ code, icon, label, cls }) => (
                  <button
                    key={code}
                    className={`sbtn ${cls}`}
                    data-active={selectedDrawerStatus === code}   // ← CSS attribute selector use karo
                    onClick={() => setSelectedDrawerStatus(code)}
                  >
                    <i className={`ti ${icon}`} aria-hidden="true"></i>
                    {label}
                  </button>
                ))}
              </div>
            </div>
            <div className="dfooter">
              <button className="btn-og btn-og-secondary btn-og-sm" onClick={() => setShowDrawer(false)}>Cancel</button>
              <button className="btn-og btn-og-primary btn-og-sm" onClick={handleDrawerSave}>Save changes</button>
            </div>
          </div>
        </>
      )}

      <StatusPicker picker={picker} onApply={applyStatus} onClose={closePicker} />
      <MarkAttendanceModal show={showModal} onClose={() => { setShowModal(false); showToast('Attendance marked successfully.'); }} />
      <Toast message={toast} onDone={() => setToast('')} />

      {loading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div >
  );
};

export default Attendance_Register;